import { ApiSimulationWrapper } from "../components/ApiSimulationWrapper"
import { CustomSimulationWrapper } from "../components/CustomSimulationWrapper"
import { SimulationWrapperType, type SimulationWrapper } from "../types"

export const createSimulationWrapperInstance = (
  simwrapper_type: SimulationWrapperType,
): SimulationWrapper | null => {
  switch (simwrapper_type) {
    case SimulationWrapperType.CUSTOM:
      return new CustomSimulationWrapper()
    case SimulationWrapperType.API_WRAPPER:
      return new ApiSimulationWrapper()
    default:
      return null
  }
}
